/* Parquelectro: put each filter option's count in its own element (.pe-fcount) so it can be
   styled as a grey pill. The theme prints it as loose text, "Label (105)". Filters are
   re-rendered over AJAX on every change, so the wrap re-runs whenever they do.
   Only active on pages that have collection filters. */
(function () {
  function wrapCounts() {
    document.querySelectorAll('.facet-checkbox__text').forEach(function (el) {
      if (el.querySelector('.pe-fcount')) return;
      for (var n = el.firstChild; n; n = n.nextSibling) {
        if (n.nodeType !== 3) continue;
        var m = n.nodeValue.match(/\((\d+)\)/);
        if (!m) continue;
        n.nodeValue = n.nodeValue.replace(m[0], '');
        var pill = document.createElement('span');
        pill.className = 'pe-fcount';
        pill.textContent = m[1];
        el.appendChild(pill);
        return;
      }
    });
  }

  function start() {
    var root = document.querySelector('.facets-vertical');
    if (!root) return;
    wrapCounts();
    var t;
    new MutationObserver(function () {
      clearTimeout(t);
      t = setTimeout(wrapCounts, 40);
    }).observe(root, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
